import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { SEO } from "@/components/SEO";

const FAQS = [
  {
    q: "How do I find the right practitioner?",
    a: "Browse by city or category — reiki, tarot, massage, coaching and more. Every practitioner on O.R.E.C has been personally vetted by the O.R.E.C team before appearing here. Read their story, services, prices, and real reviews from other seekers, then trust your gut. That feeling matters here.",
  },
  {
    q: "How does booking work?",
    a: "Pick a practitioner, choose a service, and select an open time slot from their real availability. You pay securely by card at the time of booking — no phone tag, no e-transfers to strangers. The session is instantly confirmed and appears under My Bookings.",
  },
  {
    q: "What happens after I book?",
    a: "You'll get a confirmation email right away with your session details, and a reminder before your session. The practitioner is notified too. You can view everything anytime under My Bookings.",
  },
  {
    q: "Can I cancel?",
    a: "Yes — plans change, we get it. Cancel 24 hours or more before your session and you receive a full automatic refund to your card. Cancellations inside 24 hours aren't automatically refunded, out of respect for the practitioner's reserved time. See our Policies page for full details.",
  },
  {
    q: "Is my payment safe?",
    a: "Very. Payments are processed by Stripe — the same system trusted by millions of businesses worldwide. Your card details never touch our servers, and practitioners never see your payment information.",
  },
  {
    q: "What about reviews?",
    a: "After your session you can leave an honest review to help other seekers. Our system is built to be fair to everyone — if something truly went wrong, your voice is heard and handled with care, and practitioners get a chance to make things right.",
  },
];

export default function SeekerFAQ() {
  const navigate = useNavigate();
  return (
    <div className="silk-hero min-h-[70vh] px-5 sm:px-8 py-16">
      <SEO title="How Booking Works — O.R.E.C" description="Finding a vetted practitioner, booking safely, cancellations and reviews — a first-timer's guide to Our Ripple Effect Community." />
      <div className="max-w-2xl mx-auto" data-testid="seeker-faq-page">
        <p className="text-xs uppercase tracking-[0.25em] text-muted-foreground mb-3">For Seekers</p>
        <h1 className="font-display text-4xl sm:text-5xl text-foreground mb-3">How booking works</h1>
        <p className="text-sm text-muted-foreground mb-10 leading-relaxed">
          New here? Welcome. Booking through O.R.E.C is simple, safe, and built on trust — here's everything first-timers ask.
        </p>
        <Accordion type="single" collapsible className="silk-card rounded-lg px-6" data-testid="seeker-faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`sfaq-${i}`}>
              <AccordionTrigger data-testid={`sfaq-trigger-${i}`} className="text-left font-display text-base md:text-lg text-foreground hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-muted-foreground leading-relaxed">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
        <div className="text-center mt-12">
          <p className="text-sm text-muted-foreground mb-5">Ready to find your person?</p>
          <Button data-testid="seeker-faq-browse-btn" className="rounded-full px-8" onClick={() => navigate("/browse")}>
            Browse practitioners <ArrowRight size={14} className="ml-2" />
          </Button>
        </div>
      </div>
    </div>
  );
}
